import { QRScanner, QRScannerVariant, useQrScanController } from '@my2n/qr-scanner';
import { FormattedMessage } from 'react-intl';
import { QRScanDesktopLayout } from '../../QRScanComponents/QRScanDesktopLayout';
import messages from './messages';
import { parseRfidQRCode } from './parseRfidQRCode';

interface DesktopScanQRProps {
  onSuccess: (card: string) => void;
}

export function DesktopScanQR({ onSuccess }: DesktopScanQRProps) {
  const { error, handleError, handleScan } = useQrScanController({
    onSuccess,
    parseResult: parseRfidQRCode,
  });

  return (
    <QRScanDesktopLayout
      title={<FormattedMessage {...messages.userRfidModalScanQRTitle} />}
      description={<FormattedMessage {...messages.userRfidModalScanQRText} />}
      scanAlertsMessages={{
        allowCamera: <FormattedMessage {...messages.userRfidModalScanQRAlertAllowCamera} />,
        invalidCode: <FormattedMessage {...messages.userRfidModalScanQRAlertInvalidCode} />,
        permissionDenied: <FormattedMessage {...messages.userRfidModalScanQRAlertPermissionDenied} />,
        timeout: <FormattedMessage {...messages.userRfidModalScanQRAlertTimeout} />,
      }}
      error={error}
    >
      <QRScanner onError={handleError} onScan={handleScan} variant={QRScannerVariant.Desktop} />
    </QRScanDesktopLayout>
  );
}
